import { useState } from "react";
import { Link } from "react-router-dom";
import { SectionTitle } from "./SectionTitle";

const faqs = [
  {
    q: "番木瓜漫画每日什么时候更新上架内容？",
    a: "番木瓜漫画最新上架内容每日更新，通常在晚间集中上新。关注本站「最新上架」板块即可第一时间看到当天的新作。",
  },
  {
    q: "新番导视里的作品都是当季的吗？",
    a: "是的，新番导视板块聚焦本季新作，按季度整理当季开播与开载的作品，并标注重点推荐，帮你快速锁定值得追的作品。",
  },
  {
    q: "连载新开和普通连载有什么区别？",
    a: "连载新开特指刚刚开启连载的长篇作品，适合想从头追更、见证故事起步的读者；本站会集中展示这类新开连载。",
  },
  {
    q: "如何查看作品的更新进度？",
    a: "进入作品详情页即可查看当前连载话数、更新频率与最近更新状态，热门新番与连载新开板块也会同步展示关键信息。",
  },
];

export default function FaqPreview() {
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          eyebrow="FAQ"
          title="追更常见问题"
          desc="关于更新、导视与连载的常见疑问，快速为你解答。"
          to="/faq"
          linkText="查看全部问题"
        />

        <div className="mt-8 grid grid-cols-1 gap-3">
          {faqs.map((f, i) => (
            <div
              key={f.q}
              className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
              >
                <span className="text-sm font-bold text-foreground-900 md:text-base">
                  {f.q}
                </span>
                <i
                  className={`ri-add-line text-lg text-primary-600 transition ${
                    open === i ? "rotate-45" : ""
                  }`}
                ></i>
              </button>
              {open === i && (
                <p className="border-t border-background-200 px-5 py-4 text-sm leading-7 text-foreground-600">
                  {f.a}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}